import { render, staticRenderFns } from "./yibayidanpopup.vue?vue&type=template&id=2a7afe4d&scoped=true&"
import script from "./yibayidanpopup.vue?vue&type=script&lang=js&"
export * from "./yibayidanpopup.vue?vue&type=script&lang=js&"
import style0 from "./yibayidanpopup.vue?vue&type=style&index=0&id=2a7afe4d&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7afe4d",
  null
  
)

export default component.exports